export default __webpack_public_path__ + "static/media/car-under-1.761c1521.png";